module.exports = __webpack_public_path__ + "img/img1.78c6db07.svg";